exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-wizard-back[data-v-43e33d75]{padding-left:0!important}.icon-rotated[data-v-43e33d75]{width:30px;transform:rotate(180deg)}h5[data-v-43e33d75]{font-size:20px;font-family:Nunito Sans,sans-serif}h4[data-v-43e33d75],h5[data-v-43e33d75]{font-weight:700}h4[data-v-43e33d75]{font-size:22px}.wizard-form-container[data-v-43e33d75]{max-width:500px;margin:auto;padding:5rem 0}.bg-red[data-v-43e33d75]{background-color:#b70219!important;max-width:170px!important}label[for=terms][data-v-43e33d75],label[for=terms] a[data-v-43e33d75]{font-size:1.4rem;font-weight:600}.btn[data-v-43e33d75]{padding:0 1.8rem}", ""]);

// exports
